import Cart from "./cart";
import Checkout from "./checkout";

import { makeAutoObservable, runInAction } from "mobx";
import {getKeyFromLocalStorage, loadFromLocalStorage} from "./persistence";
import MenuViewStore from "./menu/menu";
import GeneralMenuViewStore from "./menu/generalMenu";
import GeneralStore from "./general"
import OrdersStore from "./orders";
import CatalogStore from "./catalog";


export class RootStore {
    //@ts-ignore
    cartStore: Cart = new Cart()

    //@ts-ignore
    checkoutStore: Checkout = new Checkout()

    //@ts-ignore
    generalMenuStore: GeneralMenuViewStore = new GeneralMenuViewStore()

    //@ts-ignore
    menuStore: MenuViewStore = new MenuViewStore()

    //@ts-ignore
    generalStore: GeneralStore = new GeneralStore()

    //@ts-ignore
    catalogStore: CatalogStore = new CatalogStore();

    //@ts-ignore
    ordersStore: OrdersStore = new OrdersStore();

    isInited: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }


    init() {

        let value: string = "";
        try{
            value = loadFromLocalStorage();
        }catch (err){
            value = loadFromLocalStorage();
        }

        let cartStore = new Cart();
        let checkoutStore = new Checkout();
        let menuViewStore = new MenuViewStore();
        let generalMenuViewStore = new GeneralMenuViewStore();
        let generalStore = new GeneralStore();
        let ordersStore = new OrdersStore();
        let catalogStore = new CatalogStore();

        try {
            const infoMessageShowedAt = getKeyFromLocalStorage("infoMessageShowedAt")
            if (infoMessageShowedAt) {
                try {
                    menuViewStore.setInfoMessageShowedAt(new Date(infoMessageShowedAt))
                } catch (e) {}
            }
        } catch (e) {}


        if (value && value.length > 0) {
            const json = JSON.parse(value);
            if (json.cartStore) cartStore = Cart.fromJSON(json.cartStore);
            if (json.checkoutStore) checkoutStore = Checkout.fromJSON(json.checkoutStore);
            if (json.generalStore) generalStore = GeneralStore.fromJSON(json.generalStore);
            if (json.ordersStore) ordersStore =  OrdersStore.fromJSON(json.ordersStore);
        }

        runInAction(() => {
            this.cartStore = cartStore;
            this.menuStore = menuViewStore;
            this.generalMenuStore = generalMenuViewStore;
            this.checkoutStore = checkoutStore;
            this.generalStore = generalStore;
            this.ordersStore = ordersStore;
            this.catalogStore = catalogStore;
            this.isInited = true;
        })
    }
}


export let rootStore: RootStore = new RootStore()
rootStore.init();


